import { render, staticRenderFns } from "./PointOfSaleList.vue?vue&type=template&id=59ce28a0&scoped=true&"
import script from "./PointOfSaleList.vue?vue&type=script&lang=js&"
export * from "./PointOfSaleList.vue?vue&type=script&lang=js&"
import style0 from "./PointOfSaleList.vue?vue&type=style&index=0&id=59ce28a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ce28a0",
  null
  
)

export default component.exports